export default {
      id: "lang-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#lang",
      toString: function () {
        return this.url;
      }
    }